(function searchBar() {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "search-bar";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }


  const { auth } = GlobalSite.checkDependency("GlobalSite.inbentaApi");
  const searchEngineUi = GlobalSite.checkDependency("GlobalSite.searchEngineUi");
  const scrollSearchbar = GlobalSite.checkDependency("GlobalSite.scrollSearchbar");
  const getUrlParam = GlobalSite.checkDependency('GlobalSite.getUrlParam');

  $(async () => {
    const searchInput = $(".search-bar .search");
    const submitInput = $(".search-bar .submit");
    const deleteButton = $(".search-bar .delete-btn");
    const autocomplete = $(".inbenta-autocomplete");
    const urlParam = getUrlParam("q");

    if (urlParam) {
      searchInput.val(urlParam);
      submitInput.prop("disabled", false);
    }

    const inbentaAuth = await auth();

    if (inbentaAuth && urlParam) {
      setTimeout(() => {
        submitInput.click()
        submitInput.blur()
      }, 200)
    }

    inbentaAuth && searchEngineUi([searchInput, submitInput, deleteButton, autocomplete], "faq-search");

    const showMoreBtn = document.querySelector(".search-bar__results-more-btn");
    const listItems = document.querySelector(".inbenta-faq-list-items");
    const results = document.querySelector(".search-bar__results");

    const observerListItems = new MutationObserver(() => {
      const items = document.querySelectorAll(".inbenta-faq-list-items .inbenta-faq-list-item");
      const showMore = document.querySelector(".search-bar__results-more");
      const imageRight = document.querySelector(".search-bar__image-right");
      const resultsInfosNbr = document.querySelector(".search-bar__results-infos-nbr span");
      const resultsInfosText = document.querySelector(".search-bar__results-infos-txt");
      const errorInfos = document.querySelector(".search-bar__results-error");
      const errorsInfosText = document.querySelector(".search-bar__results-error-title span");

      if (items.length > 0) {
        results.classList.remove("hide");
        errorInfos.classList.add("hide");

                if (imageRight) {
          imageRight.classList.remove("hide");
        }

        resultsInfosNbr.textContent = items.length;
        resultsInfosText.textContent = `“${searchInput.val()}”`;

        showNextElementNode(true);
      } else {
        results.classList.add("hide");
        errorInfos.classList.remove("hide");
        if (imageRight) {
          imageRight.classList.add("hide");
        }

        errorsInfosText.textContent = `“${searchInput.val()}”`;

        showNextElementNode(false);
      }

      if (items.length > 5) {
        showMore.classList.remove("hide");
      } else {
        showMore.classList.add("hide");
      }
    });

    observerListItems.observe(listItems, {
      subtree: true,
      childList: true,
      attributes: true,
    });

    const showNextElementNode = (isShow) => {
      let searchBarComponent = document.querySelector("._search-bar");
      let nextElementNode = searchBarComponent.parentNode.nextElementSibling;
      if (nextElementNode && nextElementNode.nodeName === 'DIV') {
        if (isShow) {
          nextElementNode.classList.add("hide");
        } else {
          nextElementNode.classList.remove("hide");
        }
      }
    };

    const clickShowMore = () => {
      const items = document.querySelectorAll(".inbenta-faq-list-items .inbenta-faq-list-item");
      const isOpenShowMore = !Array.from(items).some(({ classList }) => classList.contains("inbenta-faq-list-item--hidden"));

      if (items.length > 5 && !isOpenShowMore) {
        items.forEach(item => item.classList.remove("inbenta-faq-list-item--hidden"));
        showMoreBtn.innerHTML = "Afficher moins de résultats";
      } else if (isOpenShowMore) {
        Array.from(items).slice(5, items.length).forEach(item => item.classList.add("inbenta-faq-list-item--hidden"));
        showMoreBtn.innerHTML = "Afficher tous les résultats";
      }
    };

    showMoreBtn.addEventListener("click", clickShowMore);

    scrollSearchbar({
      classNamePrefix: "search-bar",
      offsetInput: 45
    })
  });
})();